import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/main-layout/main-layout.component';
import { HomeComponent } from './views/pages/home/home.component';
import { LaunchApplicationComponent } from './views/pages/launch-application/launch-application.component';
import { AdminAutomatedOptionsComponent } from './views/pages/admin-automated-options/admin-automated-options.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  { path: 'admin-automated-options', component: AdminAutomatedOptionsComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'home', component: HomeComponent },
      //{ path: 'launch', component: LaunchApplicationComponent },
      //{ path: 'workflow-services', component: WorkflowServicesComponent, canActivate: [AuthGuard] },

      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ]
  }
];
